import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import { PieChart as PieChartIcon } from "lucide-react";
import { ChartCard } from "./ChartCard";
import { CustomTooltip } from "./CustomTooltip";
import { CHART_COLORS } from '../constants';

export const AttendanceDistributionChart = ({ data, isLoading }) => (
  <ChartCard title="Attendance Distribution" icon={PieChartIcon} isLoading={isLoading}>
    {/* Reduced height for compactness */}
    <div className="h-[200px]">
      <ResponsiveContainer>
        <PieChart className="p-8">
          <Pie
            data={data?.byStatus || []}
            dataKey="count"
            nameKey="status"
            cx="50%"
            cy="50%"
            outerRadius={60} 
            label={({ name, value, percent }) =>
              `${name}: ${value} (${(percent * 100).toFixed(0)}%)`
            }
          >
            {(data?.byStatus || []).map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={CHART_COLORS[index % CHART_COLORS.length]}
              />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>

    {data?.summary && (
      <div className="mt-2 grid grid-cols-3 gap-4 text-center">
        <div>
          <p className="text-sm text-gray-600">Total Appointments</p>
          <p className="text-lg font-semibold">{data.summary.totalAppointments}</p>
        </div>
        <div>
          <p className="text-sm text-gray-600">Checked In</p>
          <p className="text-lg font-semibold">{data.summary.totalCheckedIn}</p>
        </div>
        <div>
          <p className="text-sm text-gray-600">Attendance Rate</p>
          <p className="text-lg font-semibold">{data.summary.overallAttendanceRate}%</p>
        </div>
      </div>
    )}
  </ChartCard>
);
